'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAudit$002dView$0024$002dAudit$002dEntry from "./presto.-Audit-View$-Audit-Entry.js";
var $p;
/** @constructor */
function $c_Lpresto_AuditView$AuditEntry$() {
}
export { $c_Lpresto_AuditView$AuditEntry$ as $c_Lpresto_AuditView$AuditEntry$ };
$p = $c_Lpresto_AuditView$AuditEntry$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AuditView$AuditEntry$;
/** @constructor */
function $h_Lpresto_AuditView$AuditEntry$() {
}
export { $h_Lpresto_AuditView$AuditEntry$ as $h_Lpresto_AuditView$AuditEntry$ };
$h_Lpresto_AuditView$AuditEntry$.prototype = $p;
$p.l = (function() {
  return "AuditEntry";
});
$p.cFp = (function(x$0) {
  return new $j_presto$002e$002dAudit$002dView$0024$002dAudit$002dEntry.$c_Lpresto_AuditView$AuditEntry($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(0)), x$0.j(1), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(2)), x$0.j(3), x$0.j(4), x$0.j(5), x$0.j(6), x$0.j(7), x$0.j(8), x$0.j(9), x$0.j(10), x$0.j(11));
});
var $d_Lpresto_AuditView$AuditEntry$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AuditView$AuditEntry$, "presto.AuditView$AuditEntry$", ({
  EE: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_AuditView$AuditEntry$ as $d_Lpresto_AuditView$AuditEntry$ };
var $n_Lpresto_AuditView$AuditEntry$;
function $m_Lpresto_AuditView$AuditEntry$() {
  if ((!$n_Lpresto_AuditView$AuditEntry$)) {
    $n_Lpresto_AuditView$AuditEntry$ = new $c_Lpresto_AuditView$AuditEntry$();
  }
  return $n_Lpresto_AuditView$AuditEntry$;
}
export { $m_Lpresto_AuditView$AuditEntry$ as $m_Lpresto_AuditView$AuditEntry$ };
//# sourceMappingURL=presto.-Audit-View$-Audit-Entry$.js.map
